module.exports = __webpack_public_path__ + "static/media/logo-big.306547e9.png";